import { ArrowRight } from "lucide-react";
import { ModuleTitle } from "./ModuleTitle";

export function ModuleCard({
  moduleKey,
  title,
  tagline,
  description,
  icon: Icon,
  comingSoon = false,
  onClick,
  accent = "green", // 'green' | 'terra'
}) {
  const iconBg = accent === "terra" ? "bg-terracotta-500" : "bg-forest-600";
  return (
    <button
      type="button"
      data-testid={`module-card-${moduleKey}`}
      onClick={onClick}
      disabled={comingSoon}
      className={`patria-card patria-card-hover relative text-left p-6 sm:p-7 w-full flex flex-col gap-4 min-h-[220px] ${
        comingSoon ? "opacity-90 cursor-default hover:translate-y-0" : ""
      }`}
    >
      {comingSoon && (
        <span
          data-testid={`module-card-${moduleKey}-coming-soon`}
          className="absolute top-4 right-4 patria-chip-terra"
        >
          Coming soon
        </span>
      )}

      <div className="flex items-center gap-3">
        <span
          className={`inline-flex items-center justify-center h-12 w-12 rounded-full ${iconBg} text-cream-100 ${
            comingSoon ? "grayscale" : ""
          }`}
          aria-hidden
        >
          {Icon ? <Icon className="h-5 w-5" strokeWidth={1.5} /> : null}
        </span>
        <div>
          <ModuleTitle testId={`module-title-${moduleKey}`}>{title}</ModuleTitle>
          {tagline && (
            <p className="mt-1 text-xs font-sans uppercase tracking-widest text-charcoal-muted">
              {tagline}
            </p>
          )}
        </div>
      </div>

      <p className={`text-sm text-charcoal-soft leading-relaxed ${comingSoon ? "text-charcoal-muted" : ""}`}>
        {description}
      </p>

      {!comingSoon && (
        <span className="mt-auto inline-flex items-center text-forest-600 font-medium text-sm">
          Open <ArrowRight className="ml-1 h-4 w-4" strokeWidth={1.5} />
        </span>
      )}
      {comingSoon && (
        <span className="mt-auto text-xs italic text-charcoal-muted">
          Coming soon in your MyPatria rollout
        </span>
      )}
    </button>
  );
}
